import SignatureFull from './components/SignatureFull';
import * as React from 'react';
import isSignatureOptionDirty from './utils/isSignatureOptionDirty';
import discardSignatureOption from './actions/discardSignatureOption';
import saveSignatureOption from './actions/saveSignatureOption';
var SignatureOption = {
    key: 'signature',
    titleStringKey: 'optionTitle_signature',
    searchTermsStringKey: 'optionTitle_signature',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SignatureFull, null); },
        isDirty: isSignatureOptionDirty,
        onSave: saveSignatureOption,
        onDiscard: discardSignatureOption,
    },
};
export default SignatureOption;
//# sourceMappingURL=SignatureOption.js.map